module.exports = __webpack_public_path__ + "static/media/IMG_0388.c200a018.jpg";